import React, {FC, useMemo} from 'react'
import {getAllPlaceholderInfo} from '../service/templateService'

interface Props {
    data: unknown
}

export const PlaceholderLegend: FC<Props> = ({data}) => {
    const placeholders = useMemo(() => getAllPlaceholderInfo(data), [data])

    return (
        <div className="placeholder-legend">
            <span className="placeholder-legend__title">Placeholders:</span>
            <div className="placeholder-legend__items">
                {placeholders.map(({name, description, value, present}) => (
                    <div
                        key={name}
                        className={`placeholder-legend__item${present ? '' : ' placeholder-legend__item--absent'}`}
                    >
                        <span className="placeholder-legend__tooltip">{description}</span>
                        <code className="placeholder-legend__name">{'{{' + name + '}}'}</code>
                        <span className="placeholder-legend__arrow">→</span>
                        <span className="placeholder-legend__value">{value}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}
